import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ScrollableView } from '@uplift/ui-v2';
import { PatientDetailsLayoutProps } from './types';


const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    position: 'relative',
    flex: 1,
  },
  patientDetails: {
    backgroundColor: theme.palette.common.white,
    borderRight: `1px solid ${theme.palette.divider}`,
    width: '385px',
  },
  activities: {
    padding: theme.spacing(6, 5),
  },
  assessments: {
    width: '385px',
    borderLeft: `1px solid ${theme.palette.divider}`,
    '& > div': {
      flex: 1,
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  }
}));


export function DesktopLargeLayout(props: PatientDetailsLayoutProps) {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.patientDetails}>
        <ScrollableView height="100%">
          {props.patientDetails}
          {props.patientAccordions}
        </ScrollableView>
      </Box>
      <ScrollableView>
        <Box className={classes.activities}>
          {props.activities}
        </Box>
      </ScrollableView>
      <Box className={classes.assessments}>
        {props.assessments}
      </Box>
    </Box>
  );
}
